/* __next_internal_client_entry_do_not_use__  cjs */ "use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ThemeProviderNoVars;
var React = _interopRequireWildcard(require("react"));
var _system = require("@mui/system");
var _identifier = _interopRequireDefault(require("./identifier"));
var _jsxRuntime = require("react/jsx-runtime");
function ThemeProviderNoVars(param) {
    let { theme: themeInput, ...props } = param;
    const scopedTheme = _identifier.default in themeInput ? themeInput[_identifier.default] : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_system.ThemeProvider, {
        ...props,
        themeId: scopedTheme ? _identifier.default : undefined,
        theme: scopedTheme || themeInput
    });
}
